module.exports = __webpack_public_path__ + "img/no-data-img.9f4594a2.png";